import Image from 'next/image';
import { FunctionComponent } from 'react';

import icon from './log-out.svg';

const LogOutIcon: FunctionComponent<RewindIconsProps> = (props) => {
  const { className, alt = '' } = props;

  return (
    <Image
      className={className}
      priority
      src={icon}
      alt={alt}
    />
  );
};

export default LogOutIcon;
